/**
 * Class for design/pattern elements
 */
window.DesignElement = class extends qtee.customDesign.AbstractElement {

	constructor (model, paper, opts) {

		const ratio =			paper.width / model.get('Width') >= paper.height / model.get('Height')
			? paper.width / model.get('Width')
			: paper.height / model.get('Height');
		const getWidth = function () {

			if (model.get('IsBackground')) {

				return ratio * model.get('Width');

			}
			return model.get('Width');

		};
		const getHeight = function () {

			if (model.get('IsBackground')) {

				return ratio * model.get('Height');

			}
			return model.get('Height');

		};
		const x = model.get('OriginX');
		const y = model.get('OriginY');
		const scale = model.get('Scale');
		const width = getWidth();
		const height = getHeight();
		const dimensions = `&wid=${Math.round(width * scale)}&hei=${Math.round(height * scale)}`;
		let url =			model.get('PatternImageUrl')
			|| qtee.customDesign.availablePatterns.getImageUrlById(model.get('PatternId')).PatternImageUrl;

		url = url.split('&wid=')[0] + dimensions;

		super(paper.image(url, x - width / 2, y - height / 2, width, height), opts);

		this.loadFromModel(model);

	}

	ready () {

		return new Promise((resolve, reject) => {

			this.rel.paper.freeTransform(this.rel, this._opts.freeTransform, (ft, events) => {

				if (events.indexOf('scale end') > -1) {

					const s = this.getS();
					const w = Math.round(s * this._origin.width);
					const h = Math.round(s * this._origin.height);
					const oldDimensions = this.rel.node.href.baseVal.split('&wid=')[1].split('&hei=');

					if (w > oldDimensions[0] || h > oldDimensions[1]) {

						this.rel.node.href.baseVal = `${
							this.rel.node.href.baseVal.split('&wid=')[0]
						}&wid=${w}&hei=${h}`;

					}

				}
				this._opts.callback(ft, events);

			});

			resolve(this.setR(this._origin.rotation).setS(this._origin.scale).apply());

		});

	}

	saveToModel () {

		return {
			OriginX: this.getX(),
			OriginY: this.getY(),
			RotationalDegree: this.getR(),
			Scale: this.getS(),
			PatternImageUrl: this.rel.node.href.baseVal,
			ZOrder: this.zIndex
		};

	}

	loadFromModel (model) {

		this._origin = Object.freeze({
			rotation: model.get('RotationalDegree'),
			scale: model.get('Scale'),
			width: model.get('Width'),
			height: model.get('Height')
		});

		this._cid = model.cid;
		this._sid = model.id;
		this._type = model.type;
		this.zIndex = model.get('ZOrder');

	}

};
